import React from "react";
import Moralis from "moralis";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import loading from "../images/loading.gif";
import avatar from "../images/default-avatar.jpg";
import { useMoralis } from "react-moralis";
import Web3 from "web3";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

const Explore = () => {
  var abi = [
    {
      inputs: [],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "approved",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "ApprovalForAll",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "awardWinner",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "burn",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "buyNft",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "closeAuction",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "saleNumber",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "auctionTime",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "royality",
          type: "uint256",
        },
      ],
      name: "mintToken",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      inputs: [],
      name: "pause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Paused",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "bidAmount",
          type: "uint256",
        },
        {
          internalType: "address",
          name: "mmo_address",
          type: "address",
        },
      ],
      name: "placeBid",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "purchase",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "auctionTimeNeeded",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "minPrice",
          type: "uint256",
        },
      ],
      name: "putOnAuction",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
      ],
      name: "putOnSale",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "removeNft",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "retriveFromSale",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "safeMint",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "bytes",
          name: "_data",
          type: "bytes",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "setApprovalForAll",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Unpaused",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint256",
          name: "id",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "tokenMinted",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "receiver",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          internalType: "address",
          name: "mmoAddress",
          type: "address",
        },
      ],
      name: "transfermmo",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "unpause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
      ],
      name: "updatePrice",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getApproved",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getAuctionWinner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "getIdbyUri",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getMinBidPrice",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNftCreator",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNftRoyality",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNumberOfBids",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getPrice",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRemainingBidingTime",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRunnerup",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRunnerupBid",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getWinningBid",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getWinningBider",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
      ],
      name: "isApprovedForAll",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "isNftForSale",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "isNftOnAuction",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "ownerOf",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "paused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "bytes4",
          name: "interfaceId",
          type: "bytes4",
        },
      ],
      name: "supportsInterface",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenOfOwnerByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "tokenURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
  ];
  const [nfts, setNfts] = useState(null);
  const [onAuction, setOnAuction] = useState(false);
  const { user } = useMoralis();
  var nftImagesArray = [];

  useEffect(() => {
    getContractNfts();
  }, []);

  /*Start Moralis*/
  Moralis.start({
    serverUrl: "https://kquqmy2unesf.usemoralis.com:2053/server",
    appId: "lGFqxutUnQZXqqxy5N1optlMEzpT6RJW7BwbcMmw",
  });

  /*----------------------
   Fellowship function
 ------------------------*/

  async function getUser() {
    const Fellowship = Moralis.Object.extend("Fellowship");
    const query = new Moralis.Query(Fellowship);
    const results = await query.find();
    query.equalTo("fellow_id", "0x446eee880a177cde0855b462db75c00c0f9efe51");
    for (let i = 0; i < results.length; i++) {
      const object = results[i];
    }
  }

  const getContractNfts = async () => {
    const options = {
      address: "0x0c24491c7CadACc878474047c5d7972340D392C3",
      chain: "bsc",
    };
    const NFTs = await Moralis.Web3API.token.getAllTokenIds(options);
    const nftsResultObject = NFTs.result;

    /*LLLLLLLL** get NFT Metadata LOOP **LLLLLLLLLLLL*/
    for (var i = 0; i < NFTs.result.length; i++) {
      const options = {
        address: "0x0c24491c7CadACc878474047c5d7972340D392C3",
        token_id: NFTs.result[i].token_id,
        chain: "bsc",
      };
      const tokenIdMetadata = await Moralis.Web3API.token.getTokenIdMetadata(
        options
      );

      const nftOwnerOptions = {
        address: "0x0c24491c7CadACc878474047c5d7972340D392C3",
        token_id: tokenIdMetadata.token_id,
        chain: "bsc",
      };
      const tokenIdOwners = await Moralis.Web3API.token.getTokenIdOwners(
        nftOwnerOptions
      );
      const nftowner = tokenIdOwners.result[0].owner_of;

      /*+++++++++++++++++++++
       GET USER PROFILE DATA
      +++++++++++++++++++++++*/
      const query = new Moralis.Query("Profiles");
      const userEthAddress = tokenIdOwners.result[0].owner_of;
      const stringEathAddress = userEthAddress.toString();
      const upAddress = stringEathAddress.toUpperCase();

      query.startsWith("userAddress", upAddress);
      const results = await query.find();

      var ownerName;
      var proImage;

      if (results.length != 0) {
        const object = results[0];
        ownerName = object.get("name");
        proImage = object.get("pro_image");
      } else {
        ownerName = tokenIdOwners.result[0].owner_of;
        proImage = avatar;
      }

      /*--------------Get Data from Blockchain--------------------------*/
      const contract_address = "0x0c24491c7CadACc878474047c5d7972340D392C3";
      const contract_abi = abi;
      const web3 = new Web3(window.ethereum);
      const contract = new web3.eth.Contract(contract_abi, contract_address);

      const nftPrice = await contract.methods
        .getPrice(tokenIdMetadata.token_id)
        .call();
      const tokenURI = await contract.methods
        .tokenURI(tokenIdMetadata.token_id)
        .call();
      const onAuctionStatus = await contract.methods
        .isNftOnAuction(tokenIdMetadata.token_id)
        .call();
      const forSaleStatus = await contract.methods
        .isNftForSale(tokenIdMetadata.token_id)
        .call();

      const nftPriceEth = Web3.utils.fromWei(nftPrice, "ether");

      var obj;
      await fetch(tokenURI)
        .then((res) => res.json())
        .then((data) => (obj = data));
      var saleType = "";
      if (onAuctionStatus) {
        saleType = "Auction";
      } else if (forSaleStatus) {
        saleType = "Fixed Price";
      } else {
        saleType = "Sold";
      }
      var isSold = "";

      const nftDataBundle = {
        nftImageUri: obj.image,
        nftOwner: nftowner,
        nftName: obj.nftName,
        nftId: tokenIdMetadata.token_id,
        nftPrice: nftPriceEth,
        nftAuction: onAuctionStatus,
        nftSaleType: saleType,
        ownerImage: proImage,
        ownerName: ownerName,
        nftCategory: obj.category,
        isNftSold: isSold,
      };
      nftImagesArray.push(nftDataBundle);
    } //end of loop

    /*******Set NFT State to populate on the frontend**********/
    setNfts(nftImagesArray);
  };
  return (
    <div className="explorer_outer_div">
      <Tabs
        defaultActiveKey="all"
        id="explorer_filter_tabs"
        className="explorer_filter_tabs"
      >
        <Tab eventKey="all" title="All">
          <div className="row">
            {nfts &&
              nfts.map((curElem) => {
                return (
                  <div className="col-md-3 card-col">
                    <Link
                      to={`/nftdetails/${curElem.nftId}`}
                      className="card-link"
                    >
                      <div class="card explore-card">
                        <div className="card-body explore-card-body">
                          <img
                            src={curElem.nftImageUri}
                            width="200px"
                            height="300px"
                          />
                          <h5 className="card-text title">{curElem.nftName}</h5>
                          <Link
                            to={`/author/${curElem.nftOwner}`}
                            className="card-link"
                          >
                            <div className="row">
                              <div className="col-md-3 onwner_img_div">
                                <span className="onwerImg ">
                                  {" "}
                                  <img
                                    src={curElem.ownerImage}
                                    alt="Owner"
                                  />{" "}
                                </span>
                                <span>
                                  {" "}
                                  <h4 className="card-text card-link">
                                    @{curElem.ownerName}
                                  </h4>
                                </span>
                              </div>
                              <div className="col-md-9 owner_name_div"></div>
                            </div>
                          </Link>

                          <div className="row">
                            <div className="col-md-6">
                              <h5 className="card-text card-link nft-price">
                                {curElem.nftPrice} MMO
                              </h5>
                              <h6 className="card-text card-link nft-price">
                                {curElem.isNftSold}
                              </h6>
                            </div>
                            <div className="col-md-6 sale-badge-div">
                              <p className="sale-type-badge text-center">
                                {" "}
                                {curElem.nftSaleType}{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })}
            {!nfts && (
              <div className="loading-spiner-div">
                <img
                  src={loading}
                  alt="Loading...."
                  width="200px"
                  height="200px"
                />
              </div>
            )}
          </div>
        </Tab>
        <Tab eventKey="sports" title="Sports">
          <div className="row">
            {nfts &&
              nfts.map((curElem) => {
                if (curElem.nftCategory == "sports") {
                  return (
                    <div className="col-md-3 card-col">
                      <Link
                        to={`/nftdetails/${curElem.nftId}`}
                        className="card-link"
                      >
                        <div class="card explore-card">
                          <div className="card-body explore-card-body">
                            <img
                              src={curElem.nftImageUri}
                              width="200px"
                              height="300px"
                            />
                            <h5 className="card-text title">
                              {curElem.nftName}
                            </h5>
                            <Link
                              to={`/author/${curElem.nftOwner}`}
                              className="card-link"
                            >
                              <div className="row">
                                <div className="col-md-3 onwner_img_div">
                                  <span className="onwerImg ">
                                    {" "}
                                    <img
                                      src={curElem.ownerImage}
                                      alt="Owner"
                                    />{" "}
                                  </span>
                                  <span>
                                    {" "}
                                    <h4 className="card-text card-link">
                                      @{curElem.ownerName}
                                    </h4>
                                  </span>
                                </div>
                                <div className="col-md-9 owner_name_div"></div>
                              </div>
                            </Link>

                            <div className="row">
                              <div className="col-md-6">
                                <h5 className="card-text card-link nft-price">
                                  {curElem.nftPrice} MMO
                                </h5>
                                <h6 className="card-text card-link nft-price">
                                  {curElem.isNftSold}
                                </h6>
                              </div>
                              <div className="col-md-6 sale-badge-div">
                                <p className="sale-type-badge text-center">
                                  {" "}
                                  {curElem.nftSaleType}{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                }
              })}
            {!nfts && (
              <div className="loading-spiner-div">
                <img
                  src={loading}
                  alt="Loading...."
                  width="200px"
                  height="200px"
                />
              </div>
            )}
          </div>
        </Tab>

        <Tab eventKey="gaming" title="Gaming">
          <div className="row">
            {nfts &&
              nfts.map((curElem) => {
                if (curElem.nftCategory == "gaming") {
                  return (
                    <div className="col-md-3 card-col">
                      <Link
                        to={`/nftdetails/${curElem.nftId}`}
                        className="card-link"
                      >
                        <div class="card explore-card">
                          <div className="card-body explore-card-body">
                            <img
                              src={curElem.nftImageUri}
                              width="200px"
                              height="300px"
                            />
                            <h5 className="card-text title">
                              {curElem.nftName}
                            </h5>
                            <Link
                              to={`/author/${curElem.nftOwner}`}
                              className="card-link"
                            >
                              <div className="row">
                                <div className="col-md-3 onwner_img_div">
                                  <span className="onwerImg ">
                                    {" "}
                                    <img
                                      src={curElem.ownerImage}
                                      alt="Owner"
                                    />{" "}
                                  </span>
                                  <span>
                                    {" "}
                                    <h4 className="card-text card-link">
                                      @{curElem.ownerName}
                                    </h4>
                                  </span>
                                </div>
                                <div className="col-md-9 owner_name_div"></div>
                              </div>
                            </Link>

                            <div className="row">
                              <div className="col-md-6">
                                <h5 className="card-text card-link nft-price">
                                  {curElem.nftPrice} MMO
                                </h5>
                                <h6 className="card-text card-link nft-price">
                                  {curElem.isNftSold}
                                </h6>
                              </div>
                              <div className="col-md-6 sale-badge-div">
                                <p className="sale-type-badge text-center">
                                  {" "}
                                  {curElem.nftSaleType}{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                }
              })}
            {!nfts && (
              <div className="loading-spiner-div">
                <img
                  src={loading}
                  alt="Loading...."
                  width="200px"
                  height="200px"
                />
              </div>
            )}
          </div>
        </Tab>
        <Tab eventKey="collectables" title="Collectables">
          <div className="row">
            {nfts &&
              nfts.map((curElem) => {
                if (curElem.nftCategory == "collectibles") {
                  return (
                    <div className="col-md-3 card-col">
                      <Link
                        to={`/nftdetails/${curElem.nftId}`}
                        className="card-link"
                      >
                        <div class="card explore-card">
                          <div className="card-body explore-card-body">
                            <img
                              src={curElem.nftImageUri}
                              width="200px"
                              height="300px"
                            />
                            <h5 className="card-text title">
                              {curElem.nftName}
                            </h5>
                            <Link
                              to={`/author/${curElem.nftOwner}`}
                              className="card-link"
                            >
                              <div className="row">
                                <div className="col-md-3 onwner_img_div">
                                  <span className="onwerImg ">
                                    {" "}
                                    <img
                                      src={curElem.ownerImage}
                                      alt="Owner"
                                    />{" "}
                                  </span>
                                  <span>
                                    {" "}
                                    <h4 className="card-text card-link">
                                      @{curElem.ownerName}
                                    </h4>
                                  </span>
                                </div>
                                <div className="col-md-9 owner_name_div"></div>
                              </div>
                            </Link>

                            <div className="row">
                              <div className="col-md-6">
                                <h5 className="card-text card-link nft-price">
                                  {curElem.nftPrice} MMO
                                </h5>
                                <h6 className="card-text card-link nft-price">
                                  {curElem.isNftSold}
                                </h6>
                              </div>
                              <div className="col-md-6 sale-badge-div">
                                <p className="sale-type-badge text-center">
                                  {" "}
                                  {curElem.nftSaleType}{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                }
              })}
            {!nfts && (
              <div className="loading-spiner-div">
                <img
                  src={loading}
                  alt="Loading...."
                  width="200px"
                  height="200px"
                />
              </div>
            )}
          </div>
        </Tab>
        <Tab eventKey="entertainment" title="Entertainment">
          <div className="row">
            {nfts &&
              nfts.map((curElem) => {
                if (curElem.nftCategory == "entertainment") {
                  return (
                    <div className="col-md-3 card-col">
                      <Link
                        to={`/nftdetails/${curElem.nftId}`}
                        className="card-link"
                      >
                        <div class="card explore-card">
                          <div className="card-body explore-card-body">
                            <img
                              src={curElem.nftImageUri}
                              width="200px"
                              height="300px"
                            />
                            <h5 className="card-text title">
                              {curElem.nftName}
                            </h5>
                            <Link
                              to={`/author/${curElem.nftOwner}`}
                              className="card-link"
                            >
                              <div className="row">
                                <div className="col-md-3 onwner_img_div">
                                  <span className="onwerImg ">
                                    {" "}
                                    <img
                                      src={curElem.ownerImage}
                                      alt="Owner"
                                    />{" "}
                                  </span>
                                  <span>
                                    {" "}
                                    <h4 className="card-text card-link">
                                      @{curElem.ownerName}
                                    </h4>
                                  </span>
                                </div>
                                <div className="col-md-9 owner_name_div"></div>
                              </div>
                            </Link>

                            <div className="row">
                              <div className="col-md-6">
                                <h5 className="card-text card-link nft-price">
                                  {curElem.nftPrice} MMO
                                </h5>
                                <h6 className="card-text card-link nft-price">
                                  {curElem.isNftSold}
                                </h6>
                              </div>
                              <div className="col-md-6 sale-badge-div">
                                <p className="sale-type-badge text-center">
                                  {" "}
                                  {curElem.nftSaleType}{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                }
              })}
            {!nfts && (
              <div className="loading-spiner-div">
                <img
                  src={loading}
                  alt="Loading...."
                  width="200px"
                  height="200px"
                />
              </div>
            )}
          </div>
        </Tab>
        <Tab eventKey="esports" title="E-sports">
          <div className="row">
            {nfts &&
              nfts.map((curElem) => {
                if (curElem.nftCategory == "esports") {
                  return (
                    <div className="col-md-3 card-col">
                      <Link
                        to={`/nftdetails/${curElem.nftId}`}
                        className="card-link"
                      >
                        <div class="card explore-card">
                          <div className="card-body explore-card-body">
                            <img
                              src={curElem.nftImageUri}
                              width="200px"
                              height="300px"
                            />
                            <h5 className="card-text title">
                              {curElem.nftName}
                            </h5>
                            <Link
                              to={`/author/${curElem.nftOwner}`}
                              className="card-link"
                            >
                              <div className="row">
                                <div className="col-md-3 onwner_img_div">
                                  <span className="onwerImg ">
                                    {" "}
                                    <img
                                      src={curElem.ownerImage}
                                      alt="Owner"
                                    />{" "}
                                  </span>
                                  <span>
                                    {" "}
                                    <h4 className="card-text card-link">
                                      @{curElem.ownerName}
                                    </h4>
                                  </span>
                                </div>
                                <div className="col-md-9 owner_name_div"></div>
                              </div>
                            </Link>

                            <div className="row">
                              <div className="col-md-6">
                                <h5 className="card-text card-link nft-price">
                                  {curElem.nftPrice} MMO
                                </h5>
                                <h6 className="card-text card-link nft-price">
                                  {curElem.isNftSold}
                                </h6>
                              </div>
                              <div className="col-md-6 sale-badge-div">
                                <p className="sale-type-badge text-center">
                                  {" "}
                                  {curElem.nftSaleType}{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                }
              })}
            {!nfts && (
              <div className="loading-spiner-div">
                <img
                  src={loading}
                  alt="Loading...."
                  width="200px"
                  height="200px"
                />
              </div>
            )}
          </div>
        </Tab>
        <Tab eventKey="nftforgood" title="Nft for good">
          <div className="row">
            {nfts &&
              nfts.map((curElem) => {
                if (curElem.nftCategory == "nftforgood") {
                  return (
                    <div className="col-md-3 card-col">
                      <Link
                        to={`/nftdetails/${curElem.nftId}`}
                        className="card-link"
                      >
                        <div class="card explore-card">
                          <div className="card-body explore-card-body">
                            <img
                              src={curElem.nftImageUri}
                              width="200px"
                              height="300px"
                            />
                            <h5 className="card-text title">
                              {curElem.nftName}
                            </h5>
                            <Link
                              to={`/author/${curElem.nftOwner}`}
                              className="card-link"
                            >
                              <div className="row">
                                <div className="col-md-3 onwner_img_div">
                                  <span className="onwerImg ">
                                    {" "}
                                    <img
                                      src={curElem.ownerImage}
                                      alt="Owner"
                                    />{" "}
                                  </span>
                                  <span>
                                    {" "}
                                    <h4 className="card-text card-link">
                                      @{curElem.ownerName}
                                    </h4>
                                  </span>
                                </div>
                                <div className="col-md-9 owner_name_div"></div>
                              </div>
                            </Link>

                            <div className="row">
                              <div className="col-md-6">
                                <h5 className="card-text card-link nft-price">
                                  {curElem.nftPrice} MMO
                                </h5>
                                <h6 className="card-text card-link nft-price">
                                  {curElem.isNftSold}
                                </h6>
                              </div>
                              <div className="col-md-6 sale-badge-div">
                                <p className="sale-type-badge text-center">
                                  {" "}
                                  {curElem.nftSaleType}{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                }
              })}
            {!nfts && (
              <div className="loading-spiner-div">
                <img
                  src={loading}
                  alt="Loading...."
                  width="200px"
                  height="200px"
                />
              </div>
            )}
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default Explore;
